
    import { computed, defineComponent, PropType } from 'vue'
    import { DatePicker } from '@progress/kendo-vue-dateinputs'
    import { DropDownList } from '@progress/kendo-vue-dropdowns'
    import { Button } from '@progress/kendo-vue-buttons'
    import { getKendoShortDateFormat, getKendoDateFormatPlaceholder } from '@/util'
    import { filterIcon } from '@progress/kendo-svg-icons'

    interface FilterOperator {
        text: string
        operator: string
    }

    export default defineComponent({
        name: 'DateFilterCell',
        inheritAttrs: false,

        components: {
            DatePicker,
            DropDownList,
            'k-button': Button
        },

        props: {
            value: { type: Object as PropType<Date | null>, default: null },
            operator: { type: String, default: '' },
            operators: { type: Array as PropType<FilterOperator[]>, default: () => [] }
        },

        emits: ['change'],

        setup(props, { emit }) {
            const dateFormat = getKendoShortDateFormat()
            const dateFormatPlaceholder = getKendoDateFormatPlaceholder()

            const selectedOperator = computed<FilterOperator>(() =>
                props.operators.find(o => o.operator === props.operator)
                ?? props.operators[0]
                ?? { text: '', operator: '' }
            )

            const hasFilter = computed(() =>
                (props.value !== null && props.value !== undefined) || !!props.operator
            )

            function onDateChange(e: any) {
                const val: Date | null = e.value ?? null
                const op = props.operator || selectedOperator.value?.operator || ''
                emit('change', { value: val, operator: val !== null ? op : '', event: e })
            }

            function onOperatorChange(e: any) {
                emit('change', { value: props.value, operator: e.value?.operator ?? '', event: e })
            }

            function onClear() {
                emit('change', { value: null, operator: '' })
            }

            return { dateFormat, dateFormatPlaceholder, selectedOperator, hasFilter, filterIcon, onDateChange, onOperatorChange, onClear }
        }
    })
